<template>
  <div class="is-fullwidth">
    <div class="is-clearfix">
      <nuxt-link
        class="button is-primary is-pulled-right"
        :to="localePath('office-products-stone-create')"
      >{{ $t("form.create") }}</nuxt-link>

      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <nuxt-link :to="localePath('office-products')">
              {{
              $t("page.products")
              }}
            </nuxt-link>
          </li>

          <li class="is-active">
            <a aria-current="page">{{ $t('page.stone') }}</a>
          </li>
        </ul>
      </nav>
    </div>

    <pagination-control
      :controls="{ itemsPerPage, filter}"
      :pagination="$store.state.stone.pagination"
    />

    <div
      class="columns is-multiline align-boxes"
      v-if="$store.getters['stone/listForTable'].length"
    >
      <div
        class="column is-6 is-4-fullhd"
        v-for="stone in $store.getters['stone/listForTable']"
        :key="stone.id"
      >
        <nuxt-link
          :to="localePath({ name: 'office-products-stone-id', params: { id: stone.id }})"
          class="box"
        >
          <article class="media product-item">
            <figure class="media-left" v-if="stone.thumbnail">
              <p class="image is-128x128">
                <img :src="stone.thumbnail" style="object-fit: contain; object-position: center;" />
              </p>
            </figure>
            <div class="media-content">
              <div class="content">
                <p>
                  <strong>{{stone.name}}</strong>
                  <br />
                  {{ stone.industry_name }}
                </p>
              </div>
              <nav class="level is-mobile">
                <div class="level-left has-text-link">
                  <div class="level-item">
                    <span class="icon is-small" :title="$t('form.delivery_time')">
                      <i class="mdi mdi-clock-outline"></i>
                    </span>
                    &nbsp;{{stone.delivery_time}}
                  </div>
                  <div class="level-item">
                    <span class="icon is-small" :title="$t('form.product_class')">
                      <i class="mdi mdi-octagram-outline"></i>
                    </span>
                    &nbsp;{{stone.product_class}}
                  </div>
                  <div class="level-item" v-if="stone.available">
                    <span class="icon is-small" :title="$t('form.available')">
                      <i class="mdi mdi-check-all"></i>
                    </span>
                  </div>
                </div>
              </nav>
            </div>
          </article>
        </nuxt-link>
      </div>
    </div>

    <div v-else>{{$t('message.no_data')}}</div>

    <pagination class="m-t-5" :meta="$store.state.stone.pagination" />
  </div>
</template>

<script>
export default {
  watchQuery: true,

  async asyncData({ store, query, params }) {
    if (!params.skipReloding) {
      await store.dispatch("stone/fetchList", query);
    }

    let objToReturn = {};

    if (query.per_page) {
      objToReturn.itemsPerPage = query.per_page;
    }

    objToReturn.filter = query.filter;

    return objToReturn;
  }
};
</script>




// WEBPACK FOOTER //
// resources/nuxt/pages/office/products/stone/index.vue